module.exports = __webpack_public_path__ + "img/logo-home.85bcb394.png";